import React from "react";
import type { LucideIcon } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Card, CardContent } from "../../../components/ui/card";

export type ActionCardProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
};

const ActionCard = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
}: ActionCardProps) => {
  return (
    <Card className="flex flex-col border-0 bg-brand_navy text-white shadow-sm">
      <CardContent className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2">
          <Icon className="size-[18px] shrink-0 text-[#D4EBFD]" />
          <h3 className="text-[14px] font-bold">{title}</h3>
        </div>
        <p className="mt-2 flex-1 text-[13px] font-medium text-[#D4EBFD]">
          {description}
        </p>
        <Button
          variant="outline"
          onClick={onAction}
          className="mt-4 h-10 w-full border-white/60 bg-transparent text-[12px] font-medium text-white hover:bg-white/10 hover:text-white"
        >
          {actionLabel}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ActionCard;
